/** Format a value as a signed amount with thousands separators, e.g. +1,489.94. */
export function formatSigned(value: number, fractionDigits = 2): string {
  return `${value >= 0 ? '+' : '-'}${Math.abs(value).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
}

/** Format a plain balance with thousands separators, e.g. 7,057.81. */
export function formatBalance(value: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Format a 'YYYY.MM.DD' trade date into 'Sep 10, 2026'. */
export function formatTradeDate(input: string): string {
  const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const [year, month, day] = input.split('.').map(Number);
  const label = MONTHS[month - 1] ?? '';
  return `${label} ${day}, ${year}`;
}

/** Format a 'YYYY-MM-DD' date into 'Sep 10, 2026'. */
export function formatIsoDate(input: string): string {
  const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const [year, month, day] = input.split('-').map(Number);
  if (!year || !month || !day) return input;
  return `${MONTHS[month - 1]} ${day}, ${year}`;
}